import IBimageKneestabilityatloadingresponse1 from '@/pages/ReportV2/components/Modals/assets/IBimageKneestabilityatloadingresponse1.png';
import IBimageKneestabilityatloadingresponse2 from '@/pages/ReportV2/components/Modals/assets/IBimageKneestabilityatloadingresponse2.png';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import { VerticalSwiper } from '@/components/swiper';

// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

export const KneeStabilityLoadingResponseModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageKneestabilityatloadingresponse1} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  After initial contact the leg has to accept the body weight. The load increases until the point of
                  single limb support (carrying the full body weight) and midstance. To absorb the shock and establish a
                  good balance, all joints contribute by flexing slightly.
                  <br></br>
                  <br></br>
                  In the frontal plane, hip abductors, <i>tensor fascia latae</i> and upper portions of the{' '}
                  <i>m. gluteus maximus</i> control drop of the contralateral pelvis (this effectively is relative hip
                  adduction). The anterior gluteals move the hip joint into internal rotation, rotating the pelvis
                  slightly forward on the opposite side.
                  <br></br>
                  <br></br>
                  In the chain pelvis – hip – knee – ankle, the knee is the weakest link. This is not only due to its
                  relatively unstable architecture; the way it functions largely depends on how the adjacent joints
                  behave.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid style={{ height: '100%' }}>
            <IonRow class='ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageKneestabilityatloadingresponse2} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  Throughout Loading Response, the pressure on the tibia plateau (and the menisci) should be increased
                  evenly. When hip and or ankle fail, this will immediately impact the knee joint. As a result distorted
                  patterns will appear in all anatomical planes (also see: varus valgus).
                  <br></br>
                  <br></br>
                  <strong>Causes poor stability</strong>
                  <br></br>
                  Poor stability is typically due to:
                  <ul>
                    <li>Weak quadriceps</li>
                    <li>Fear</li>
                    <li>Pain</li>
                    <li>Excessive stride length</li>
                    <li>Too high heels (inlays)</li>
                  </ul>
                  <strong>Additional analysis</strong>
                  <br></br>
                  The knee should be extended properly in anticipation to Initial Contact (approximately &lt; 10°
                  flexion). Poor knee extension can be due to a weak <i>m. vastus medialis</i>, flexion contracture, or
                  difference in limb length.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
